module.exports = __webpack_public_path__ + "img/1.17371c5f.svg";